// extracted by mini-css-extract-plugin
export default {"enterName":"EnterName_enterName__h-IhH"};